// extracted by mini-css-extract-plugin
export var closeIcon = "popUpHeader-module--closeIcon--kk9df";
export var popUpHeader = "popUpHeader-module--popUpHeader--WAtaH";
export var popUpTitleClosed = "popUpHeader-module--popUpTitleClosed--EzD10";
export var popUpTitleOpen = "popUpHeader-module--popUpTitleOpen--m6G8Y";